import { Link, useSearchParams } from 'react-router-dom'
import { FaFacebook, FaInstagram, FaYoutube, FaPhone } from 'react-icons/fa'
import { useEffect } from 'react'
import { useTranslation, Trans } from 'react-i18next'

const ThankYouPage = ({ returnPath = '/', returnLabel, contentCategory, landingMode = false }) => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()

    useEffect(() => {
        window.scrollTo(0, 0)
        // Meta Pixel: SPA-compliant event firing with UTM enrichment
        if (typeof fbq === 'function') {
            fbq('track', 'PageView')
            const leadData = {}
            if (contentCategory) leadData.content_category = contentCategory
            const utmContent = searchParams.get('utm_content')
            if (utmContent) leadData.content_name = utmContent
            fbq('track', 'Lead', Object.keys(leadData).length ? leadData : undefined)
        }
    }, [])

    return (
        <section className="flex flex-col justify-center items-center px-4 min-h-screen text-center bg-black">
            {/* Logo */}
            <div className="mb-12">
                <img
                    src="/logo.webp"
                    alt={t('success.logo_alt', 'JD Rivero Logo')}
                    className="object-contain w-48 sm:w-64"
                />
            </div>

            {/* Success Message */}
            <div className="mx-auto mb-16 space-y-6 max-w-2xl">
                <h1 className="text-4xl font-black tracking-widest text-white uppercase sm:text-5xl">
                    {t('thank_you.title')}
                </h1>
                <p className="text-xl font-light leading-relaxed text-gray-400">
                    <Trans i18nKey="thank_you.message" />
                </p>

                <div className="pt-8 border-t border-gray-800">
                    <p className="mb-6 text-lg font-medium text-white">
                        {landingMode ? t('success.landing_cta', 'Need immediate assistance? Call us:') : t('success.urgent_message')}
                    </p>
                    <div className="flex flex-col gap-4 justify-center items-center sm:flex-row">
                        {!landingMode && (
                            <a href="tel:+12144620683" className="flex gap-3 justify-center items-center px-6 py-3 w-full bg-gray-900 rounded-lg border border-gray-700 transition hover:border-primary hover:text-white group sm:w-auto">
                                <FaPhone className="w-5 h-5 transition-transform text-primary group-hover:scale-110" />
                                <span className="text-gray-300 group-hover:text-white"><span className="text-gray-500 font-bold text-[10px] mr-2 uppercase tracking-tighter">{t('regions.texas')}</span>(214) 462 0683</span>
                            </a>
                        )}
                        <a href="tel:+17862961439" className="flex gap-3 justify-center items-center px-6 py-3 w-full bg-gray-900 rounded-lg border border-gray-700 transition hover:border-primary hover:text-white group sm:w-auto">
                            <FaPhone className="w-5 h-5 transition-transform text-primary group-hover:scale-110" />
                            <span className="text-gray-300 group-hover:text-white">{!landingMode && <span className="text-gray-500 font-bold text-[10px] mr-2 uppercase tracking-tighter">{t('regions.florida')}</span>}(786) 296 1439</span>
                        </a>
                    </div>
                </div>
            </div>

            {/* Social Media Links */}
            <div className="flex gap-8 mb-16">
                <a
                    href="https://www.facebook.com/jdriveroinc/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 transition-transform hover:text-white hover:scale-110"
                >
                    <FaFacebook className="text-3xl" />
                </a>
                <a
                    href="https://www.instagram.com/stories/highlights/18076407466817371/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 transition-transform hover:text-white hover:scale-110"
                >
                    <FaInstagram className="text-3xl" />
                </a>
                <a
                    href="https://www.youtube.com/@jdrivero4394"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 transition-transform hover:text-white hover:scale-110"
                >
                    <FaYoutube className="text-3xl" />
                </a>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col gap-4 sm:flex-row">
                <Link
                    to={returnPath}
                    className="bg-primary hover:bg-yellow-400 text-black px-10 py-4 rounded-full font-bold uppercase tracking-[0.2em] transition-all hover:scale-105 shadow-lg shadow-primary/20"
                >
                    {returnLabel || t('thank_you.back_bu')}
                </Link>
                <Link
                    to="/"
                    className="bg-gray-800 hover:bg-gray-700 text-white px-10 py-4 rounded-full font-bold uppercase tracking-[0.2em] transition-all hover:scale-105 border border-gray-700"
                >
                    {t('success.home_button')}
                </Link>
            </div>
        </section>
    )
}

export default ThankYouPage
